import { Lock, ShieldCheck } from "lucide-react";

import { Button } from "@/components/ui/button";
import Typography from "@/components/ui/typography";

const LockedState = () => {
  return (
    <div className="relative rounded-2xl border-2 border-dashed border-sds-neutral-40 bg-[#f9f9f9] p-8 sm:p-12">
      <div className="flex flex-col items-center justify-center text-center max-w-md mx-auto">
        <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-sds-purple-20 mb-6">
          <Lock className="h-8 w-8 text-sds-purple-100" />
        </div>

        <Typography size="h2" className="text-[#1e1e24] mb-2">
          AI Lead Finder
        </Typography>

        <Typography size="b2" className="text-[#767677] mb-6">
          Unlock AI-powered lead generation to find your ideal clients
          automatically. This feature is available for certified Stack founders.
        </Typography>

        <div className="flex flex-col sm:flex-row gap-3 w-full sm:w-auto">
          <Button
            className="bg-sds-purple-100 hover:bg-sds-purple-80 text-white rounded-lg px-6 h-10"
            onClick={() => {
              // In a real app, this would link to certification info
              window.open("https://launch.stack.expert/c/ai-consulting-playbook/sections/700504/lessons/3065480", "_blank");
            }}
          >
            <ShieldCheck className="mr-2 h-4 w-4" />
            Get Certified
          </Button>
        </div>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-4 w-full">
          <div className="bg-white rounded-xl p-4 border border-[#e8e8e8]">
            <Typography
              size="l2"
              className="font-semibold text-[#1e1e24] mb-1"
            >
              200 leads
            </Typography>
            <Typography size="b2" className="text-[#767677] text-xs">
              Monthly AI-generated leads tailored to your niche
            </Typography>
          </div>
          <div className="bg-white rounded-xl p-4 border border-[#e8e8e8]">
            <Typography
              size="l2"
              className="font-semibold text-[#1e1e24] mb-1"
            >
              Smart targeting
            </Typography>
            <Typography size="b2" className="text-[#767677] text-xs">
              AI builds queries from your ICP and location
            </Typography>
          </div>
          <div className="bg-white rounded-xl p-4 border border-[#e8e8e8]">
            <Typography
              size="l2"
              className="font-semibold text-[#1e1e24] mb-1"
            >
              Enriched data
            </Typography>
            <Typography size="b2" className="text-[#767677] text-xs">
              Company details, contacts, and confidence scores
            </Typography>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LockedState;
